import { SpeechRecognitionMobileAdapter } from '../directives/speech-recognition/speech-recognition-mobile-adapter';
import { SpeechRecognitionWebAdapter } from '../directives/speech-recognition/speech-recognition-web-adapter';
import { isFromMobileApp } from '../helpers';
import { SPEECH_ADAPTER } from '../tokens/speech-adapter.token';

export function speechAdapterFactory() {
  return isFromMobileApp()
    ? new SpeechRecognitionMobileAdapter()
    : new SpeechRecognitionWebAdapter();
}

export const SPEECH_ADAPTER_PROVIDER = {
  provide: SPEECH_ADAPTER,
  useFactory: speechAdapterFactory,
};
